export class KnocknocVersion {
  constructor({ str, major, minor, patch, beta, betaStr, betaNum, commits, hash, dirty }) {
    this.str = str;
    this.major = major;
    this.minor = minor;
    this.patch = patch;
    this.beta = beta;
    this.betaStr = betaStr;
    this.betaNum = betaNum || 0;
    this.commits = commits || 0;
    this.hash = hash || "";
    this.dirty = dirty || false;
  }

  compare(other) {
    if (this.major !== other.major) return this.major - other.major;
    if (this.minor !== other.minor) return this.minor - other.minor;
    if (this.patch !== other.patch) return this.patch - other.patch;

    // prerelease are lesser than non-prerelease
    if (Boolean(this.hash) !== Boolean(other.hash)) return this.hash ? -1 : 1;

    // Betas are lesser than non-betas
    if (this.beta !== other.beta) return this.beta ? -1 : 1;

    if (this.beta && other.beta && this.betaNum !== other.betaNum) {
      return this.betaNum - other.betaNum;
    }

    if (this.commits !== other.commits) return this.commits - other.commits;

    if (this.dirty !== other.dirty) return this.dirty ? -1 : 1;

    return 0;
  }

  eq(other) {
    return this.compare(other) === 0;
  }

  eqs(other) {
    return this.eq(parseKnocknocVersion(other));
  }

  gt(other) {
    return this.compare(other) > 0;
  }

  gts(other) {
    return this.gt(parseKnocknocVersion(other));
  }

  gte(other) {
    return this.compare(other) >= 0;
  }

  gtes(other) {
    return this.gte(parseKnocknocVersion(other));
  }

  lt(other) {
    return this.compare(other) < 0;
  }

  lts(other) {
    return this.lt(parseKnocknocVersion(other));
  }

  lte(other) {
    return this.compare(other) <= 0;
  }

  ltes(other) {
    return this.lte(parseKnocknocVersion(other));
  }
}

const versionRegex = /^(\d+)\.(\d+)\.(\d+)(?:-(beta\d+?))?(?:[-.](\d+)[-.](g[a-fA-F0-9]+)(\.dirty)?)?(\.dirty)?$/;

export function parseKnocknocVersion(s) {
  const m = versionRegex.exec(s);
  if (!m) {
    throw new Error(`invalid version string: ${s}`);
  }

  const major = parseInt(m[1], 10);
  const minor = parseInt(m[2], 10);
  const patch = parseInt(m[3], 10);
  const betaStr = m[4] || "";
  const commits = m[5] ? parseInt(m[5], 10) : 0;
  const hash = m[6] || "";
  const dirty = !!(m[7] || m[8]);

  let betaNum = 0;
  let beta = false;
  if (betaStr) {
    beta = true;
    const num = parseInt(betaStr.slice("beta".length), 10);
    if (!isNaN(num)) {
      betaNum = num;
    }
  }

  return new KnocknocVersion({
    str: s,
    major,
    minor,
    patch,
    beta,
    betaStr,
    betaNum,
    commits,
    hash,
    dirty,
  });
}
